module.exports = __webpack_public_path__ + "logo-service-lead-management.7e8125bd9d690c32a2b0.svg";